"use strict";

var _possibleConstructorReturn = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var NewsTagPublicDTO = function NewsTagPublicDTO() {
  _classCallCheck(this, NewsTagPublicDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], NewsTagPublicDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsTagPublicDTO.prototype, "slug", void 0);

exports.NewsTagPublicDTO = NewsTagPublicDTO;

var NewsTagPrivateDTO =
/*#__PURE__*/
function (_NewsTagPublicDTO) {
  _inherits(NewsTagPrivateDTO, _NewsTagPublicDTO);

  function NewsTagPrivateDTO() {
    _classCallCheck(this, NewsTagPrivateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewsTagPrivateDTO).apply(this, arguments));
  }

  return NewsTagPrivateDTO;
}(NewsTagPublicDTO);

__decorate([class_validator_1.IsDateString(), class_validator_1.IsOptional(), __metadata("design:type", Date)], NewsTagPrivateDTO.prototype, "deleteDate", void 0);

exports.NewsTagPrivateDTO = NewsTagPrivateDTO;

var NewsTagCreationDTO = function NewsTagCreationDTO() {
  _classCallCheck(this, NewsTagCreationDTO);
};

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], NewsTagCreationDTO.prototype, "slug", void 0);

exports.NewsTagCreationDTO = NewsTagCreationDTO;

var NewsTagUpdateDTO =
/*#__PURE__*/
function (_NewsTagCreationDTO) {
  _inherits(NewsTagUpdateDTO, _NewsTagCreationDTO);

  function NewsTagUpdateDTO() {
    _classCallCheck(this, NewsTagUpdateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewsTagUpdateDTO).apply(this, arguments));
  }

  return NewsTagUpdateDTO;
}(NewsTagCreationDTO);

exports.NewsTagUpdateDTO = NewsTagUpdateDTO;